declare var swal: any;
import { Component, OnInit, Input, AfterViewInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { ActorProfileRequest, ActorProfileController, ActorImageController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, GuardianInfoController, GuardianInfoRequest, SaveCustomerMessageRequest, CustomerMessageRequest, CustomerMessageController } from '../../../../models/actor/actor';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdUploadActorImageModal } from '../modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorPersonalInfoController, ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController } from '../../../../models/profileinfo/profileinfo.model';
import { AppFeaturesList } from '../../../../constants/constants';
//import  './profilesteps.js';
import { HCPService } from '../../../../services/hcp.service';
declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { routerTransition } from '../../../../animations/router.animations';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';

@Component({
  selector: 'profileviewpartner',
  templateUrl: './profileviewpartner.component.html',
  styleUrls: ['./profileviewpartner.component.scss'],
  animations: [routerTransition()]
})

export class ProfileViewPartnerComponent implements OnInit, AfterViewInit, OnChanges {
    @Output() GoBack: EventEmitter<any> = new EventEmitter();
  //Variable Declaration
  currentPage: string = "About"
  public isRequesting: boolean = false;
  CurrentActorProfileRequest: ActorProfileRequest;
  CurrentActorProfileController: ActorProfileController;
  public ApiResData: ApiResponseModel;

  ValueChangeActorPersonalInfoController: ActorPersonalInfoController;
  ValueChangeActorImageController: ActorImageController;
    public FormattedCodeapp: any;
  public Displaynameapp: any;
  @Input()
    public titleapp: any;
  @Input() NurseActorCode: number = 0;
  @Input() ActorCode: number;
  @Input() FormattedCode: number;
    @Input() DisplayName: string;
    @Input() titlepro: string;
  //
  //public FormattedCode: number = 0;
  public IsSetAccessRights: boolean;
  public CanEditProfileInfo: number = 0;
  public CanEditContactInfo: number = 0;
  public CanShowProfileInfo: number = 0;
  public CanShowContactInfo: number = 0;

  public CanShowProfileSummary: number = 0;
  public CanEditProfileSummary: number = 0;

  public CanShowJobPreferences: number = 0;
  public CanEditJobPreferences: number = 0;

  public CanShowEducation: number = 0;
  public CanEditEducation: number = 0;

  public CanShowEmploymentHistory: number = 0;
  public CanEditEmploymentHistory: number = 0;

  public CanShowReferences: number = 0;
  public CanEditReferences: number = 0;

  public CanShowIdentities: number = 0;
  public CanEditIdentities: number = 0;

  public CanShowCertifications: number = 0;
  public CanEditCertifications: number = 0;

  public CanShowMedicalFitness: number = 0;
  public CanEditMedicalFitness: number = 0;

  public CanShowProfileImage: number = 0;
  public CanEditProfileImage: number = 0;

  public CanShowLegalinfo: number = 0;
  public CanEditLegalinfo: number = 0;
  public showprofile: boolean = true;
  public showmessages: boolean = false;
  public showdashboard: boolean = false;
  public ShowpatientDeatils: boolean = true;

  @Input()
  public navigationMethod: string;//= "HtmlTag"; // Routing etc..
  //

  CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
  CurrentActorContactInfoController: ActorPersonalDetailInfoController;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
  CurrentSaveCustomerMessageRequest: SaveCustomerMessageRequest;
  LoadPatients(FormattedCode:number) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPatientInfoByFormattedCodeController(FormattedCode);
  }
  SelectedPatient: PatientInfoByFormattedCodeController;
  GetPatientInfoByFormattedCodeController(FormattedCode:number) {
      this.StartRefreshing();   
      this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode.toString();
    
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    //alert(this.FormattedCode);
    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          this.stopRefreshing();
          //   this.LoadGuardian();
          this.LoadMessages();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentCustomerMessageController: CustomerMessageController[];
  CurrentCustomerMessageRequest: CustomerMessageRequest;
  LoadMessages() {
    this.CurrentCustomerMessageRequest = new CustomerMessageRequest();


    this.CurrentCustomerMessageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCustomerMessageController();
  }
  //SelectedPatientGuarianDetails: GuardianInfoController;
  GetCustomerMessageController() {
    this.StartRefreshing();


    this.CurrentCustomerMessageRequest.ActorCode = this.SelectedPatient.ActorCode;//43572;
    this.CurrentCustomerMessageRequest.ConditionalOperator = 10;
    this.CurrentCustomerMessageRequest.MessageCode = 0;
    this.CurrentCustomerMessageRequest.Who2Who = "FromProvider";
    this.actorservice.GetCustomerMessageController(this.CurrentCustomerMessageRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCustomerMessageController = this.ApiResData.Result;
          //this.SelectedPatientGuarianDetails = this.CurrentGuardianInfoController[0];


          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private actorservice: ActorService, private hcpservice: HCPService, private tosterservice: NGXToastrService,
    private modalService: NgbModal) {

    //stepObject.init();
    //webGlObject.init();
  }
    ngOnChanges(changes: SimpleChanges) {
        if (this.FormattedCode != null && this.FormattedCode != 0) {
            this.RefreshPatientDetails(this.FormattedCode);
        }
    }

    ngOnInit() {
      if (this.navigationMethod == 'HtmlTag') {
        $.getScript('./healins-assets/js/jquery.steps.js');
        $.getScript('./healins-assets/js/profilesteps.js');
        //this.FormattedCodeapp = this.route.snapshot.paramMap.get('FormattedCode');
        //this.Displaynameapp = this.route.snapshot.paramMap.get('DisplayName');
        //this.titleapp = this.route.snapshot.paramMap.get('title');

     //   alert(this.titleapp);

        if (this.titleapp == "App" || this.titleapp == "cycle") {
          //alert('Helo')
          this.RefreshPatientDetails(this.FormattedCodeapp);
        }
      }
      else {
        $.getScript('./healins-assets/js/jquery.steps.js');
        $.getScript('./healins-assets/js/profilesteps.js');
        this.FormattedCodeapp = this.route.snapshot.paramMap.get('FormattedCode');
        this.Displaynameapp = this.route.snapshot.paramMap.get('DisplayName');
        this.titleapp = this.route.snapshot.paramMap.get('title');

      //  alert(this.titleapp);

        if (this.titleapp == "App" || this.titleapp == "cycle") {
          //alert('Helo')
          this.RefreshPatientDetails(this.FormattedCodeapp);
        }
      }
    }

    RefreshPatientDetails(FormattedCode:number) {
    ///////////////////////
    this.LoadPatients(FormattedCode);
    //this.LoadMessages();
    this.CurrentSaveCustomerMessageRequest = new SaveCustomerMessageRequest();
    this.CurrentSaveCustomerMessageRequest.ConditionalOperator = 10;

    this.CurrentSaveCustomerMessageRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
    this.CurrentActorContactInfoController = new ActorPersonalDetailInfoController();
    this.CurrentActorPersonalDetailInfoRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.onSetFeatureAccessConfig();

    this.CurrentActorProfileRequest = new ActorProfileRequest();
    this.CurrentActorProfileController = new ActorProfileController();
    if (this.NurseActorCode > 0) {
      this.CurrentActorProfileRequest.ActorCode = this.NurseActorCode;
    }
    else {
      this.CurrentActorProfileRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    this.CurrentActorProfileRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetActorProfileController();

    this.ValueChangeActorPersonalInfoController = new ActorPersonalInfoController();
    this.ValueChangeActorImageController = new ActorImageController();
    // Horizontal Timeline js for user timeline
    //$.getScript('./assets/js/vertical-timeline.js');
    //



  }

  ngAfterViewInit() {
    // pSteps.loadStep();
  }

  onSetFeatureAccessConfig() {


    //Features
    var PersonalInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_PersonalInfo.toUpperCase())
    var ContactInfo_FeaturesList = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ContactInfo.toUpperCase())

    //
    var Feature_NurseProfile_ProfileSummary = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileSummary.toUpperCase())
    var Feature_NurseProfile_JobPreferences = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_JobPreferences.toUpperCase())

    var Feature_NurseProfile_Education = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Education.toUpperCase())

    var Feature_NurseProfile_EmploymentHistory = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_EmploymentHistory.toUpperCase())

    var Feature_NurseProfile_References = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_References.toUpperCase())

    var Feature_NurseProfile_Identities = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Identities.toUpperCase())
    var Feature_NurseProfile_Certifications = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Certifications.toUpperCase())

    var Feature_NurseProfile_MedicalFitness = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_MedicalFitness.toUpperCase())

    var Feature_NurseProfile_ProfileImage = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_ProfileImage.toUpperCase())

    var Feature_NurseProfile_Legalinfo = AppData.Instance().AppUserSettingInfo.RoleFeatureLinkInfoController.
      filter(x => x.FeatureID.toUpperCase() === AppFeaturesList.Feature_NurseProfile_Legalinfo.toUpperCase())


    //

    if (PersonalInfo_FeaturesList.length > 0) {
      if (PersonalInfo_FeaturesList[0].Edit === true) {
        this.CanEditProfileInfo = 1;
      }
      if (PersonalInfo_FeaturesList[0].List === true) {
        this.CanShowProfileInfo = 1;
        //this.GetActorPersonalDetailInfoController();
      }
    }
    if (ContactInfo_FeaturesList.length > 0) {
      if (ContactInfo_FeaturesList[0].Edit === true) {
        this.CanEditContactInfo = 1;
      }
      if (ContactInfo_FeaturesList[0].List === true) {
        this.CanShowContactInfo = 1;
      }
    }

    //
    if (Feature_NurseProfile_ProfileSummary.length > 0) {
      if (Feature_NurseProfile_ProfileSummary[0].Edit === true) {
        this.CanEditProfileSummary = 1;
      }
      if (Feature_NurseProfile_ProfileSummary[0].List === true) {
        this.CanShowProfileSummary = 1;
      }
    }

    if (Feature_NurseProfile_JobPreferences.length > 0) {
      if (Feature_NurseProfile_JobPreferences[0].Edit === true) {
        this.CanEditJobPreferences = 1;
      }
      if (Feature_NurseProfile_JobPreferences[0].List === true) {
        this.CanShowJobPreferences = 1;
      }
    }

    if (Feature_NurseProfile_Education.length > 0) {
      if (Feature_NurseProfile_Education[0].Edit === true) {
        this.CanEditEducation = 1;
      }
      if (Feature_NurseProfile_Education[0].List === true) {
        this.CanShowEducation = 1;
      }
    }

    if (Feature_NurseProfile_EmploymentHistory.length > 0) {
      if (Feature_NurseProfile_EmploymentHistory[0].Edit === true) {
        this.CanEditEmploymentHistory = 1;
      }
      if (Feature_NurseProfile_EmploymentHistory[0].List === true) {
        this.CanShowEmploymentHistory = 1;
      }
    }

    if (Feature_NurseProfile_References.length > 0) {
      if (Feature_NurseProfile_References[0].Edit === true) {
        this.CanEditReferences = 1;
      }
      if (Feature_NurseProfile_References[0].List === true) {
        this.CanShowReferences = 1;
      }
    }

    if (Feature_NurseProfile_Identities.length > 0) {
      if (Feature_NurseProfile_Identities[0].Edit === true) {
        this.CanEditIdentities = 1;
      }
      if (Feature_NurseProfile_Identities[0].List === true) {
        this.CanShowIdentities = 1;
      }
    }

    if (Feature_NurseProfile_Certifications.length > 0) {
      if (Feature_NurseProfile_Certifications[0].Edit === true) {
        this.CanEditCertifications = 1;
      }
      if (Feature_NurseProfile_Certifications[0].List === true) {
        this.CanShowCertifications = 1;
      }
    }

    if (Feature_NurseProfile_MedicalFitness.length > 0) {
      if (Feature_NurseProfile_MedicalFitness[0].Edit === true) {
        this.CanEditMedicalFitness = 1;
      }
      if (Feature_NurseProfile_MedicalFitness[0].List === true) {
        this.CanShowMedicalFitness = 1;
      }
    }

    if (Feature_NurseProfile_ProfileImage.length > 0) {
      if (Feature_NurseProfile_ProfileImage[0].Edit === true) {
        this.CanEditProfileImage = 1;
      }
      if (Feature_NurseProfile_ProfileImage[0].List === true) {
        this.CanShowProfileImage = 1;
      }
    }

    if (Feature_NurseProfile_Legalinfo.length > 0) {
      if (Feature_NurseProfile_Legalinfo[0].Edit === true) {
        this.CanEditLegalinfo = 1;
      }
      if (Feature_NurseProfile_Legalinfo[0].List === true) {
        this.CanShowLegalinfo = 1;
      }
    }
    this.IsSetAccessRights = true;





    //
  }
  //
  GetActorPersonalDetailInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          this.CurrentActorContactInfoController = this.ApiResData.Result[0];

          this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorContactInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorContactInfoController.Salutation;
          this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorContactInfoController.FirstName;
          this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorContactInfoController.MiddleName;
          this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorContactInfoController.LastName;
          this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorContactInfoController.DisplayName;
          this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorContactInfoController.SocialSecurityNumber;
          this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorContactInfoController.DateOfBirth;
          this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorContactInfoController.PlaceOfBirth;
          this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorContactInfoController.Gender;
          this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorContactInfoController.BloodGroup;
          this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorContactInfoController.Nationality;
          this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorContactInfoController.Religion;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorContactInfoController.BirthIdentification1;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorContactInfoController.BirthIdentification2;
          this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorContactInfoController.LiveIn;
          this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorContactInfoController.Occupation;
          this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorContactInfoController.MaritalStatus;
          this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorContactInfoController.HasWorkPermit;
          this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorContactInfoController.IsConvicted;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorContactInfoController.LanguagesSpoken;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorContactInfoController.LanguagesRead;

          //
          //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorContactInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorContactInfoController.AddressLine1;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorContactInfoController.AddressLine2;
          this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorContactInfoController.City;
          this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorContactInfoController.State;
          this.CurrentActorPersonalDetailInfoRequest.Country = this.CurrentActorContactInfoController.Country;
          this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorContactInfoController.Telephone1;
          this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorContactInfoController.Telephone2;
          this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorContactInfoController.Fax1;
          this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorContactInfoController.Fax2;
          this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorContactInfoController.Email;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorContactInfoController.EmergencyContactPersonName;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorContactInfoController.EmergencyContactNo1;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorContactInfoController.EmergencyContactNo2;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorContactInfoController.EmergencyAddress;

          //
          this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorContactInfoController.ProfileSummary;
          this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorContactInfoController.ProfileTitle;


          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  //

  showPage(page: string) {
    this.currentPage = page;
  }
   
  BackToProfile() {
      //alert("method");
      if (this.titleapp == "cycle") {
          this.router.navigate(['healins/dashboard']);
      }
  
    this.showdashboard = true;
      this.ShowpatientDeatils = false;
      this.GoBack.emit();

  }
  onpersonalInfoChange(event: any) {
    // console.log('onpersonalInfoChange');

    if (event != null) {

      this.ValueChangeActorPersonalInfoController = event;
      //console.log('this.ValueChangeActorPersonalInfoController.DisplayName--->' + this.ValueChangeActorPersonalInfoController.DisplayName);
      //this.ValueChangeActorPersonalInfoController.DisplayName = this.CurrentActorProfileController.DisplayName;
      if (this.ValueChangeActorPersonalInfoController.DisplayName != null) {
        this.CurrentActorProfileController.DisplayName = this.ValueChangeActorPersonalInfoController.DisplayName;
      }


    }

  }
  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorProfileController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }



  GetActorProfileController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.actorservice.GetActorProfileController(this.CurrentActorProfileRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentActorProfileController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  closeResult: string;
  // This function is used in open
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // Open content with dark section
  openContent() {
    alert('open dialog');
    if (this.CurrentActorProfileController.ActorImageCode != null && this.CurrentActorProfileController.ActorImageCode > 0) {
      const modalRef = this.modalService.open(NgbdUploadActorImageModal, {
        centered: true
      })//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorImageCode = this.CurrentActorProfileController.ActorImageCode;
      modalRef.componentInstance.ActorCode = this.CurrentActorProfileController.ActorCode;
      modalRef.componentInstance.ActorImageFile == this.CurrentActorProfileController.ActorImageFile;
      modalRef.componentInstance.ActorImageFileExtension = this.CurrentActorProfileController.ActorImageFileExtension;

      modalRef.result.then(x => { this.GetActorProfileController() })
      //modalRef.result(result => { this.GetActorProfileController() })
      // modalRef.close(result => { this.GetActorProfileController(); })
    }
    else {
      alertFunctions.AlertParam('you dont have Permission to Upload...!');
    }
  }
  viewprofile() {
    this.showprofile = true;
    this.showmessages = false;
  }
  viewmessages() {
    this.showprofile = false;
    this.showmessages = true;
  }
  onSubmit() {
    // alert("On Submit");
    this.CurrentSaveCustomerMessageRequest.ProviderActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.CurrentSaveCustomerMessageRequest.CustomerActorCode = this.SelectedPatient.ActorCode;
    this.CurrentSaveCustomerMessageRequest.CustomerMessageCode = 0;
    this.CurrentSaveCustomerMessageRequest.MessageStatus = "NEW";
    this.CurrentSaveCustomerMessageRequest.ParentCode = 0;
    this.CurrentSaveCustomerMessageRequest.ThreadID = 0;
    this.CurrentSaveCustomerMessageRequest.CreatedUser = AppData.Instance().UserLoginDetails.UserName;
    //this.CurrentSaveCustomerMessageRequest.CreatedTimeStamp = new Date();
    this.CurrentSaveCustomerMessageRequest.Who2Who = "FromProvider";
    this.actorservice.SaveCustomerMessage(this.CurrentSaveCustomerMessageRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.LoadMessages();
            //alert(this.ApiResData.Result);

            //this.ShowList = true;
            //this.clearData2();


            this.stopRefreshing();
            this.LoadMessageByCode(this.ApiResData.Result);
            //  this.CurrentCustomerMessageController.push(justAdded);
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  LoadMessageByCode(code: number) {
    //alert(code);
    this.StartRefreshing();
    var getMsg: CustomerMessageRequest = new CustomerMessageRequest();


    getMsg.SendApiRequestModel = AppData.Instance().ApiRequestParms;


    getMsg.ActorCode = this.SelectedPatient.ActorCode;//43572;
    getMsg.ConditionalOperator = 20;
    getMsg.MessageCode = code;
    getMsg.Who2Who = "FromProvider";
    this.actorservice.GetCustomerMessageController(getMsg)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var getController: CustomerMessageController[];
          // = new CustomerMessageController[];
          getController = this.ApiResData.Result;
          //this.SelectedPatientGuarianDetails = this.CurrentGuardianInfoController[0];
          if (getController.length > 0) {
            this.CurrentCustomerMessageController.push(getController[0]);
          }

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
}
